<div class="col-12">
    <p-messages></p-messages>
    <p-toast key="tst"></p-toast>
    <div class="grid">
        <div class="col-12">
            <h2>Applications ({{applications.length}}) 
            <i *ngIf="!gettingApplications" class="pi pi-refresh" style="cursor:pointer" (click)="getApplications()"></i>
            <i *ngIf="gettingApplications" class="pi pi-refresh pi-spin"></i></h2>
        </div>
        <div *ngFor="let applicant of applications" class="mt-3 col-12 sm:col-12 md:col-4 lg:col-3">
            <div class="card shadow-6 h-full" [ngStyle]="{'background-color': (applicant.Status == 'Complete') ? '#7fff0030' : (applicant.Status == 'Cancelled') ? '#f853583a' : ''}">
                <div class="grid">
                    <div class="col-12 pb-0" style="display:inline-flex">
                        <h5>Name: {{applicant.FirstName}} {{applicant.LastName}}</h5>
                        <button pButton pRipple type="button" icon="pi pi-eye" class="p-button-rounded p-button-text" pTooltip="View Application" (click)="viewSpecificApplication(applicant.Email, applicant.id)" style="margin-top:-8px"></button>
                        <button pButton pRipple type="button" icon="pi pi-download" class="p-button-rounded p-button-text" pTooltip="Download raw data" (click)="downloadSpecificApplicationData(applicant.Email, applicant.id)" style="margin-top:-8px"></button>
                    </div>
                    <div class="col-12 pb-1 pt-0">
                        <p>Applied {{applicant.CreateTimestamp | date: 'short'}}</p>
                    </div>
                    <div class="col-12 pt-0 pb-0">
                        <h6 style="word-wrap:break-word">Email: <a href="mailto:{{applicant.Email}}">{{applicant.Email}}</a></h6>
                    </div>
                    <div class="col-12 pt-0 pb-0">
                        <h6>Phone: {{applicant.PhoneNumber}}</h6>
                    </div>
                    <div class="col-12 pt-0 pb-0">
                        <button pButton pRipple type="button" icon="pi pi-plus" class="p-button-rounded p-button-text" pTooltip="Add New Tag" (click)="openAddNewTag(applicant.id, applicant.Email, applicant.Tags)"></button>
                        <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text" pTooltip="Mark Application Completed" (click)="markApplicationComplete(applicant.id, applicant.Email)"></button>
                        <button pButton pRipple type="button" icon="pi pi-stop-circle" class="p-button-rounded p-button-text" pTooltip="Mark Application Cancelled" (click)="markApplicationCancelled(applicant.id, applicant.Email)"></button>
                        <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-text" pTooltip="Clear Application Status" (click)="clearStatus(applicant.id, applicant.Email)"></button>
                    </div>
                    <div class="col-12">
                        <p-tag *ngFor="let tag of applicant.Tags; let i = index" styleClass="mr-1 mb-1" [ngStyle]="{'cursor':'pointer'}" severity="info" value="{{tag}}" (click)="removeTag(applicant.id, applicant.Email, applicant.Tags, tag)" pTooltip="Click to remove"></p-tag>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <h2>Leads ({{leads.length}}) 
            <i *ngIf="!gettingLeads" class="pi pi-refresh" style="cursor:pointer" (click)="getLoanLeads()"></i>
            <i *ngIf="gettingLeads" class="pi pi-refresh pi-spin"></i>
            </h2>
        </div>
        <div *ngFor="let lead of leads" class="col-12 sm:col-12 md:col-4 lg:col-3">
            <div class="card shadow-6">
                <div class="grid">
                    <div class="col-12"  style="display:inline-flex">
                        <h5>Name: {{lead.FirstName}} {{lead.LastName}}</h5>
                        <button *ngIf="!deletingLead" pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-text" pTooltip="Delete Lead" (click)="deleteLead(lead.PK, lead.SK)" style="margin-top:-8px"></button>
                        <button *ngIf="deletingLead" pButton pRipple type="button" icon="pi pi-spin pi-spinner" class="p-button-rounded p-button-text" style="margin-top:-8px"></button>
                    </div>
                    <div class="col-12">
                        <h6 style="word-wrap:break-word">Email: <a href="mailto:{{lead.Email}}">{{lead.Email}}</a></h6>
                    </div>
                    <div class="col-12">
                        <h6>Phone: {{lead.PhoneNumber}}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-dialog [(visible)]="showTagDialog">
    <ng-template pTemplate="header">
        <h4>Add new tag</h4>
    </ng-template>
    <div class="card" style="text-align:center">
        <div class="p-fluid">
            <input pInputText (keydown.enter)="addNewTag()" placeholder="Name" [(ngModel)]="tagText">
        </div>
        
    </div>
    <p-footer>
        <button pButton type="button" class="p-button-danger" label="Cancel" icon="pi pi-times" (click)="showTagDialog = false"></button>
        <button [disabled]="addingTag" pButton type="button" class="p-button-success" label="Add" icon="pi pi-check" (click)="addNewTag()"></button>
    </p-footer>
</p-dialog>
